import loadable from '@loadable/component'

export default Object.assign({
    '/obt': loadable(() => import('./Home')),
    '/obt/analysis': loadable(() => import('./AnswerAnalysis')),
    '/obt/result': loadable(() => import('./ResultPage')),
    '/obt/mock/old/analysis': loadable(() => import('./MockAnswerAnalysis')), // 模考专用解析
    '/obt/mock/analysis': loadable(() => import('./MockAnswerAnalysis/index_v2')), // 模考专用解析
    // 兼容老路由
    '/w/mokao/intelligentTopic': loadable(() => import('./Home')),
    '/w/exerciseFashuo': loadable(() => import('./Home')),
    '/w/exercise/result/:any': loadable(() => import('./AnswerAnalysis')),
    '/w/answerAnalysis': loadable(() => import('./AnswerAnalysis'))
})
